import React from "react";
import {
    ActionRow,
    ActionRowButton,
    ActionRowDropdownButton,
    DropdownItem,
    DropdownItemGroup,
    DropdownItemGroups,
    Icon
} from "peggirkit";
import {ArrowPathIcon, ArrowsRightLeftIcon, BookOpenIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import {SetStateFn} from "@/utils/SetStateUtils";

type Props = {
    loadingUpdatingStatus: boolean,
    setLoadingUpdatingStatus: SetStateFn<boolean>,
    setShowSynchronizeMenuModal: SetStateFn<boolean>,
};

const SynchronizationOverviewHeadingActions = ({
                                                   loadingUpdatingStatus,
                                                   setLoadingUpdatingStatus,
                                                   setShowSynchronizeMenuModal,
                                               }: Props) => {
    return (
        <ActionRow>
            <ActionRowDropdownButton
                color={"secondary"}
                iconBefore={<Icon icon={ArrowsRightLeftIcon}/>}
                items={
                    <DropdownItemGroups>
                        <DropdownItemGroup>
                            <DropdownItem
                                icon={<Icon icon={BookOpenIcon}/>}
                                buttonAction={{
                                    as: "button",
                                    actionProps: {
                                        onClick: () => setShowSynchronizeMenuModal(true),
                                    },
                                }}
                            >
                                <FormattedMessage id={"restaurantMenu"}/>
                            </DropdownItem>
                        </DropdownItemGroup>
                    </DropdownItemGroups>
                }
            >
                <FormattedMessage id={"synchronize"}/>
            </ActionRowDropdownButton>

            <ActionRowButton
                iconBefore={<Icon icon={ArrowPathIcon}/>}
                loading={loadingUpdatingStatus}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setLoadingUpdatingStatus(true)
                    },
                }}
            >
                <FormattedMessage id={"refreshStatus"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default SynchronizationOverviewHeadingActions;